// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__isQj1","header":"ReportDetails_header__26rAb","title":"ReportDetails_title__3irp9","left":"ReportDetails_left__2CYKT"};